import Vue from 'vue'
import SelectModalComponent from './index.vue'

// 创建SelectModal构造函数
const SelectModalConstructor = Vue.extend(SelectModalComponent)

let instance
let seed = 1

// 创建实例
const SelectModal = function (options = {}) {
  if (Vue.prototype.$isServer) return

  // 如果已有实例且正在显示，先关闭
  if (instance && instance.visible) {
    instance.visible = false
  }

  const id = 'select_modal_' + seed++

  instance = new SelectModalConstructor({})

  instance.id = id
  instance.$mount()
  document.body.appendChild(instance.$el)

  return instance.show(options)
}

// // 快捷方法
// SelectModal.alert = function(message, title, options = {}) {
//   return SelectModal({
//     type: 'alert',
//     title: title || '提示',
//     message: message,
//     showClose: false,
//     ...options
//   })
// }

// SelectModal.confirm = function(message, title, options = {}) {
//   return SelectModal({
//     type: 'confirm',
//     title: title || '确认',
//     message: message,
//     ...options
//   })
// }

// SelectModal.prompt = function(message, title, options = {}) {
//   return SelectModal({
//     type: 'input',
//     title: title || '输入',
//     message: message,
//     ...options
//   })
// }

// SelectModal.select = function(options, title, selectOptions = {}) {
//   return SelectModal({
//     type: 'select',
//     title: title || '选择',
//     options: options,
//     ...selectOptions
//   })
// }

// 插件安装函数
SelectModal.install = function (Vue) {
  Vue.prototype.$selectModal = SelectModal
}

export default SelectModal
